import { useState, useRef } from "react";
import { Button, StaticAlert, Textarea } from "components";
import { Formik, Field } from "formik";
import { VALIDATION_MESSAGES } from "enums";
import { useBackOrder } from "hooks/orders";
import { usePWA } from "hooks/usePWA";
import { notifyOfflineOnlyAction } from "utils";
import * as Yup from "yup";

interface AppointmentCannotHappenProps {
  handleCloseOrder: () => void;
  uuid: string | undefined;
  type: string;
  groupUuid?: string | null;
}

const AppointmentCannotHappen = ({
  handleCloseOrder,
  type,
  uuid,
  groupUuid,
}: AppointmentCannotHappenProps) => {
  const [isAppointmentCannotHappen, setIsAppointmentCannotHappen] =
    useState(false);
  const { isOffline } = usePWA();
  const isMeasurement = type === "measurement";
  const leftButtonLabel = isMeasurement
    ? "Pomiar nie może się odbyć"
    : "Montaż nie może się odbyć";
  const rightButtonLabel = isMeasurement
    ? "Zamknij zlecenie"
    : "Zakończ zlecenie";

  const { mutate: backOrder } = useBackOrder({
    onSuccess: () => {
      handleCloseOrder();
    },
    onError: (error: Error) => {
      console.error(error);
    },
  });

  const handleSubmit = (values: any) => {
    backOrder(values);
  };

  const validationSchema = Yup.object().shape({
    comment: Yup.string().required(VALIDATION_MESSAGES.REQUIRED),
  });

  const commentRef = useRef<HTMLDivElement>(null);

  const handleLeftButtonClick = () => {
    setIsAppointmentCannotHappen(true);
    setTimeout(() => {
      commentRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };

  return (
    <>
      <div className="active-order__buttons">
        <Button
          stroke
          label={leftButtonLabel}
          onClick={() => {
            if (isOffline) {
              notifyOfflineOnlyAction();
              return;
            }

            handleLeftButtonClick();
          }}
        />
        <Button
          label={rightButtonLabel}
          className="active-order__measurement-button"
          onClick={() => {
            if (isOffline) {
              notifyOfflineOnlyAction();
              return;
            }

            handleCloseOrder();
          }}
        />
      </div>

      {isOffline
        ? null
        : isAppointmentCannotHappen && (
            <div ref={commentRef}>
              <div className="active-order__cant-happen">
                <StaticAlert
                  className="checklist__alert"
                  show={true}
                  label={`Uzupełnij komentarz poniżej, wpisując dlaczego ${
                    isMeasurement ? "pomiar" : "montaż"
                  } nie może się odbyć`}
                />
              </div>
              <Formik
                initialValues={{ comment: "", orderUuid: uuid, groupUuid }}
                enableReinitialize
                validationSchema={validationSchema}
                onSubmit={async (values: any) => handleSubmit(values)}
              >
                {({ errors, handleSubmit }) => (
                  <form
                    className="active-order__cant-happen__form"
                    onSubmit={handleSubmit}
                  >
                    <Field
                      name="comment"
                      label="Komentarz"
                      maxLength={255}
                      component={Textarea}
                      errors={errors}
                    />

                    <div className="active-order__cant-happen__form-button">
                      <Button
                        label="Zatwierdź"
                        size="small"
                        onClick={() => handleSubmit()}
                      />
                    </div>
                  </form>
                )}
              </Formik>
            </div>
          )}
    </>
  );
};

export default AppointmentCannotHappen;
